import * as Yup from 'yup';
import * as validator from 'components/Common/InputBox/validator';

Yup.addMethod(Yup.string, 'engNumChar', validator.engNumChar);
Yup.addMethod(Yup.string, 'noSpaceInFront', validator.noSpaceInFront);

export const jobTitleSchema = () => {
  return Yup.object().shape({
    compStrcCd: Yup.string().required('MB_M_REQUIRED').engNumChar('MB_M_ONLY_ENG_NUM').noSpaceInFront(), // 필수값, 영문과 숫자만 가능 한글불가능
    compStrcCdNm: Yup.string().required('MB_M_REQUIRED').noSpaceInFront(), // 필수값
  });
};

export default jobTitleSchema;
